{
  "es": {
    "constants": {
      "address": {
        "city": "Ciudad",
        "country": "País",
        "number": "Número",
        "street": "Calle",
        "zip": "Código postal"
      },
      "crud": {
        "created_at": "Creado el",
        "deleted_at": "Eliminado el",
        "updated_at": "Actualizado el"
      },
      "currencies": {
        "all": "Todas las divisas",
        "popular": "Populares"
      },
      "days": ["D", "L", "M", "X", "J", "V", "S"],
      "languages": {
        "de": "Alemán",
        "en": "Inglés",
        "es": "Español",
        "fallback_info": "Parece que esto no está disponible en tu idioma. En su lugar, estamos usando la traducción en {fallback_locale} existente.",
        "fr": "Francés",
        "it": "Italiano",
        "nl": "Neerlandés",
        "pl": "Polaco",
        "pt": "Portugués"
      },
      "languages_short": {
        "de": "DE",
        "en": "EN",
        "es": "ES",
        "fr": "FR",
        "it": "IT",
        "nl": "NL",
        "pl": "PL",
        "pt": "PT"
      },
      "measurements": {
        "imperial": "Imperial",
        "metric": "Métrico",
        "surface": {
          "imperial": "Sq. ft",
          "metric": "m²",
          "null": ""
        }
      },
      "months": [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
      ],
      "profile_statuses": {
        "active": "Activo",
        "added": "Sin invitar",
        "blocked": "Desactivado",
        "discarded": "Eliminado",
        "invited": "Invitado",
        "invited_at": "Invitado"
      },
      "profile_statuses_descriptive": {
        "active": "Última vez activo en la plataforma: {session_ended_at}",
        "added": "Sin invitar",
        "blocked": "Desactivado",
        "discarded": "Eliminado",
        "invited": "Invitado pero aún no se ha registrado",
        "invited_at": "Invitado el {invited_at}. Aún no se ha registrado"
      },
      "profile_titles": {
        "dr": "Doctor",
        "mr": "Señor",
        "mrs": "Señora",
        "professor": "Profesor",
        "sirmadam": "-"
      },
      "time_units": {
        "days": "Días",
        "months": "Meses",
        "weeks": "Semanas"
      },
      "time_units_count": {
        "days": "ningún día | día | días",
        "months": "ningún mes | mes | meses",
        "weeks": "ninguna semana | semana | semanas"
      },
      "timezone_regions": {
        "Africa": "África",
        "America": "América",
        "Asia": "Asia",
        "Atlantic": "Atlántico",
        "Australia": "Australia",
        "Europe": "Europa",
        "Pacific": "Pacífico"
      },
      "timezones": {
        "Africa/Abidjan": "África/Abiyán",
        "Africa/Cairo": "África/El Cairo",
        "Africa/Casablanca": "África/Casablanca",
        "Africa/Johannesburg": "África/Johannesburgo",
        "Africa/Lagos": "África/Lagos",
        "Africa/Nairobi": "África/Nairobi",
        "America/Anchorage": "América/Anchorage",
        "America/Bogota": "América/Bogotá",
        "America/Buenos_Aires": "América/Buenos Aires",
        "America/Chicago": "América/Chicago",
        "America/Denver": "América/Denver",
        "America/Halifax": "América/Halifax",
        "America/Lima": "América/Lima",
        "America/Los_Angeles": "América/Los Ángeles",
        "America/Mexico_City": "América/Ciudad de México",
        "America/New_York": "América/Nueva York",
        "America/Phoenix": "América/Phoenix",
        "America/Santiago": "América/Santiago",
        "America/Sao_Paulo": "América/São Paulo",
        "America/St_Johns": "América/St. John's",
        "America/Toronto": "América/Toronto",
        "America/Vancouver": "América/Vancouver",
        "Asia/Bangkok": "Asia/Bangkok",
        "Asia/Colombo": "Asia/Colombo",
        "Asia/Dhaka": "Asia/Daca",
        "Asia/Dubai": "Asia/Dubái",
        "Asia/Ho_Chi_Minh": "Asia/Ho Chi Minh",
        "Asia/Hong_Kong": "Asia/Hong Kong",
        "Asia/Jakarta": "Asia/Yakarta",
        "Asia/Karachi": "Asia/Karachi",
        "Asia/Kolkata": "Asia/Calcuta",
        "Asia/Kuala_Lumpur": "Asia/Kuala Lumpur",
        "Asia/Makassar": "Asia/Makassar",
        "Asia/Manila": "Asia/Manila",
        "Asia/Riyadh": "Asia/Riad",
        "Asia/Seoul": "Asia/Seúl",
        "Asia/Shanghai": "Asia/Shanghái",
        "Asia/Singapore": "Asia/Singapur",
        "Asia/Taipei": "Asia/Taipéi",
        "Asia/Tehran": "Asia/Teherán",
        "Asia/Tokyo": "Asia/Tokio",
        "Atlantic/Reykjavik": "Atlántico/Reikiavik",
        "Australia/Adelaide": "Australia/Adelaida",
        "Australia/Brisbane": "Australia/Brisbane",
        "Australia/Darwin": "Australia/Darwin",
        "Australia/Hobart": "Australia/Hobart",
        "Australia/Melbourne": "Australia/Melbourne",
        "Australia/Perth": "Australia/Perth",
        "Australia/Sydney": "Australia/Sídney",
        "Europe/Amsterdam": "Europa/Ámsterdam",
        "Europe/Athens": "Europa/Atenas",
        "Europe/Belgrade": "Europa/Belgrado",
        "Europe/Berlin": "Europa/Berlín",
        "Europe/Brussels": "Europa/Bruselas",
        "Europe/Bucharest": "Europa/Bucarest",
        "Europe/Budapest": "Europa/Budapest",
        "Europe/Copenhagen": "Europa/Copenhague",
        "Europe/Dublin": "Europa/Dublín",
        "Europe/Helsinki": "Europa/Helsinki",
        "Europe/Istanbul": "Europa/Estambul",
        "Europe/Lisbon": "Europa/Lisboa",
        "Europe/London": "Europa/Londres",
        "Europe/Madrid": "Europa/Madrid",
        "Europe/Moscow": "Europa/Moscú",
        "Europe/Oslo": "Europa/Oslo",
        "Europe/Paris": "Europa/París",
        "Europe/Prague": "Europa/Praga",
        "Europe/Rome": "Europa/Roma",
        "Europe/Stockholm": "Europa/Estocolmo",
        "Europe/Vienna": "Europa/Viena",
        "Europe/Warsaw": "Europa/Varsovia",
        "Europe/Zurich": "Europa/Zúrich",
        "Pacific/Auckland": "Pacífico/Auckland",
        "Pacific/Fiji": "Pacífico/Fiyi",
        "Pacific/Honolulu": "Pacífico/Honolulu"
      },
      "wind_orientations": {
        "east": "Este",
        "north": "Norte",
        "northeast": "Noreste",
        "northwest": "Noroeste",
        "select": "Seleccionar orientación",
        "south": "Sur",
        "southeast": "Sureste",
        "southwest": "Suroeste",
        "west": "Oeste"
      }
    }
  }
}
